// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__T_ThA","buttons":"PendingPaymentAlert_buttons__H_liE"};